import React, { Component } from "react";
// eslint-disable-next-line
import FloatingActionButton from "material-ui/FloatingActionButton";
// eslint-disable-next-line
import MicrophoneIcon from "material-ui/svg-icons/av/mic";
// eslint-disable-next-line
import MicrophoneOffIcon from "material-ui/svg-icons/av/mic-off";
import { Howl } from "howler";
import "./agile-quote.css";
// import "./dark-voice.css";

const darkVoiceSound = new Howl({
  src: ["dark-voice.mp3"]
});

class AgileQuoteComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sound: false
    };
  }

  disableSound() {
    this.setState({ sound: false });
    darkVoiceSound.pause();
  }

  enableSound() {
    this.setState({ sound: true });
    darkVoiceSound.play();
    // Fires when the sound finishes playing.
    darkVoiceSound.on("end", () => {
      this.disableSound();
    });
  }

  render() {
    return (
      <div className="agile-quote">
        <p className="quote">
          <span className="quote-marks">&ldquo;</span>
          {/* <span className="quote-content">
            Arise, arise, Coders of Github! Fell deeds awake, fire and
            slaughter! spear shall be shaken, shield be splintered, a sword-day,
            a red day, ere the sun rises! Ride now, ride now! Ride to Gondor!
          </span>
          <span className="quote-author">- Théoden, son of Thengel</span> */}
          <div className="dark-voice">
          <div class="LI-profile-badge"  data-version="v1" data-size="medium" data-locale="en_US" data-type="vertical" data-theme="dark" data-vanity="parv3sh"><a class="LI-simple-link" href='https://au.linkedin.com/in/parv3sh?trk=profile-badge'>PARVESH K.</a></div>
            <p className="text-center">
              {/* <b className="dark-voice-tag">&#x3C;darkVoice&#x3E; </b> */}
              <br />
              {/* In the world of 1000 frameworks, I'm fighting for the cause of
              clean and well structured code. No bug can stop me. No build-tool
              will dominate me. When the tests fail and the linting breaks, I
              will remain. */}
              Experience is the name everyone gives to their mistakes. – Oscar Wilde
              <br />
              {/* <b className="dark-voice-tag">&#x3C;/darkVoice&#x3E;</b> */}
            </p>
            {/* <div className="microphone-action">
              {!this.state.sound && (
                <FloatingActionButton
                  backgroundColor="#A80202"
                  onClick={this.enableSound.bind(this)}
                >
                  <MicrophoneIcon />
                </FloatingActionButton>
              )}
              {this.state.sound && (
                <FloatingActionButton
                  backgroundColor="#A80202"
                  onClick={this.disableSound.bind(this)}
                >
                  <MicrophoneOffIcon />
                </FloatingActionButton>
              )}
            </div> */}
          </div>
        </p>
      </div>
    );
  }
}

export default AgileQuoteComponent;
